<template>
  <client-only>
    <div>
      <div class="section_inner">
        <AgentHeader :title="pageTitle" :text="pageSubTitle" />

        <SmartalertsSettings :agent-code="agentCode" />
      </div>
    </div>
  </client-only>
</template>

<script>
import SmartalertsSettings from '@/components/Candidates/Pages/SmartalertsSettings/SmartalertsSettings';
import AgentHeader from '@/components/Smart_Agent/Header/AgentHeader';
import { t } from '@/store/modules/homeDrushim/constantsContent';
import SeoOptimization from '@/components/mixins/SeoOptimization';
import { UPDATE_SMART_ALERTS_DATA } from '@/lib/api.js';

export default {
  layout: 'personalFullWidth',
  name: 'smartAlertsPage',
  mixins: [SeoOptimization],

  components: {
    SmartalertsSettings,
    AgentHeader,
  },

  data() {
    return {
      pageTitle: t`titles.candidates.smartAgentTitle`,
      pageSubTitle: t`titles.candidates.smartAgentSubTitle`,
      agentCode: null,
    };
  },

  async fetch(context) {
    const { agentcode } = context.route.query;
    try {
      const { data } = await context.$axios(`${UPDATE_SMART_ALERTS_DATA}`, {
        params: {
          agentcode: agentcode,
        },
      });

      if (data.IsRedirect) {
        let redirectUrl = data.RedirectTo ? data.RedirectTo : '/';
        context.redirect(307, redirectUrl);
        return;
      }

      await context.store.commit('INIT_ALL_SETTINGS', data);
      this.seodata = {
        metaData: data.SEO.MetaDataItems,
        pageTitle: data.SEO.title,
        canonicalUrl: data.SEO.canonicalUrl,
      };
    } catch (err) {
      console.log(err);
    }
  },

  mounted() {
    const { agentcode } = this.$route.query;
    this.agentCode = agentcode;
  },
  head() {
    return {
      title: 'רישום לסוכן החכם | דרושים IL',
      link: [
        {
          rel: 'canonical',
          href: 'https://www.drushim.co.il/smartalerts.aspx',
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.theme--light.v-expansion-panels
  .v-expansion-panels__container
  .v-expansion-panels__header
  .v-expansion-panels__header__icon
  .v-icon {
  color: #fff;
  font-size: 30px;
}
</style>
